namespace TabAurous.SalesOrder {
    export namespace SalesOrderService {
        export const baseUrl = 'SalesOrder/SalesOrder';

        export declare function Create(request: Serenity.SaveRequest<SalesOrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SalesOrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SalesOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetCustomerandProductDetails(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SalesOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLineNo(request: Serenity.ServiceRequest, onSuccess?: (response: Common.GetLineNoResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "SalesOrder/SalesOrder/Create",
            Update = "SalesOrder/SalesOrder/Update",
            Delete = "SalesOrder/SalesOrder/Delete",
            Retrieve = "SalesOrder/SalesOrder/Retrieve",
            GetCustomerandProductDetails = "SalesOrder/SalesOrder/GetCustomerandProductDetails",
            List = "SalesOrder/SalesOrder/List",
            GetLineNo = "SalesOrder/SalesOrder/GetLineNo"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetCustomerandProductDetails', 
            'List', 
            'GetLineNo'
        ].forEach(x => {
            (<any>SalesOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
